import { useState, useMemo, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Stack,
} from "@mui/material";
import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import * as services from "./../../services/customer";

const PersonalInfoForm = ({ formData }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [customer, setCustomer] = useState("");
  const [farmers, setFarmers] = useState([]);

  useEffect(() => {
    setCustomer(formData);
    fetchFarmer(formData.id);
  }, []);
  const fetchFarmer = async (id) => {
    try {
      let res = await services.getCustomeFarmerByCustomerID(id);
      const rawData = res.data?.data || [];
      const mapped = rawData.map((farmer, index) => ({
        id: farmer.id,
        firstName: farmer.firstName || "-",
        lastName: farmer.lastName || "-",
        phone: farmer.phone || "-",
      }));
      setFarmers(mapped);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  // filter ชื่อ / นามสกุล / เบอร์โทร
  const filteredFarmers = useMemo(() => {
    const keyword = search.trim().toLowerCase();
    if (!keyword) return farmers;

    return farmers.filter(
      (f) =>
        `${f.firstName} ${f.lastName}`.toLowerCase().includes(keyword) ||
        f.phone.includes(keyword),
    );
  }, [search, farmers]);

  return (
    <Box sx={{ p: 4 }}>
      <Toaster position="bottom-right" reverseOrder={false} />

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">รายชื่อเกษตรกร</Typography>
        <Button
          variant="contained"
          onClick={() =>
            window.open(
              `/customers/farmers?customer_id=${customer.id}`,
              "_blank",
            )
          }
        >
          เพิ่มเกษตรกร
        </Button>
      </Box>

      {/* ช่องค้นหา */}
      <TextField
        fullWidth
        size="small"
        label="ค้นหาชื่อ / เบอร์โทร"
        placeholder="พิมพ์ชื่อ นามสกุล หรือเบอร์โทร"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 2 }}
      />

      {/* ตาราง */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ชื่อ</TableCell>
              <TableCell>นามสกุล</TableCell>
              <TableCell>เบอร์โทร</TableCell>
              <TableCell align="center">จัดการ</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredFarmers.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  ไม่พบข้อมูล
                </TableCell>
              </TableRow>
            ) : (
              filteredFarmers.map((farmer) => (
                <TableRow key={farmer.id}>
                  <TableCell>{farmer.firstName}</TableCell>
                  <TableCell>{farmer.lastName}</TableCell>
                  <TableCell>{farmer.phone}</TableCell>
                  <TableCell align="center">
                    <Stack direction="row" spacing={2} justifyContent="center">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() =>
                          window.open(
                            `/customers/farmers/${farmer.id}`,
                            "_blank",
                            "noopener,noreferrer",
                          )
                        }
                      >
                        ดูรายละเอียด
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() =>
                          window.open(
                            `/customers/farmers/upload/${farmer.id}`,
                            "_blank",
                            "noopener,noreferrer",
                          )
                        }
                      >
                        นำเข้าไฟล์
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PersonalInfoForm;
